import { useQuery } from 'react-query';
import { getPrivateApi } from '../../services/api';
import {
  GetInvoiceProductsIntegrationEntitiesResponse,
  GetInvoiceProductsIntegrationEntitiesResponseSchema,
} from '@vy/api-definition';
import { CustomBaseUseQueryOptions } from './requests-types/custom-use-query-options';
import { queryKeys } from '../../services/query-key/query-keys';

export function useProductsIntegrationEntities(
  invoiceId: string,
  options?: CustomBaseUseQueryOptions<GetInvoiceProductsIntegrationEntitiesResponse>,
) {
  return useQuery(
    queryKeys.productsIntegrationEntities(invoiceId),
    async () => {
      const api = getPrivateApi();
      const getInvoiceProductsIntegrationEntitiesResponse = await api.getInvoiceProductsIntegrationEntities({
        invoiceId,
      });

      return GetInvoiceProductsIntegrationEntitiesResponseSchema.parse(
        getInvoiceProductsIntegrationEntitiesResponse,
      );
    },
    options,
  );
}
